// The commit this bundle was built from, resolved at build time by
// craco.config.js (see plugins/build-info/resolve-build-info.js) and compiled
// in — nothing here reads git or the network.
//
// The same values are served as a static /build-info.json, so a person can
// answer "what is running?" with one curl and see the same answer the screen
// shows. Fields are named as `GET /api/` names them.
import { APP_VERSION } from "./releaseNotes";

/**
 * Reported whenever the build could not be established. Never a plausible
 * placeholder: a missing answer sends someone to look elsewhere, whereas a
 * confidently stale one sends them home.
 */
export const UNKNOWN = "unknown";

/**
 * A build field as injected, or the explicit unknown marker. An absent or blank
 * injection is the half-configured build — it must read as "unknown", not as an
 * empty gap a reader skips straight past.
 */
export const stampedValue = (value) => String(value == null ? "" : value).trim() || UNKNOWN;

export const BUILD = stampedValue(process.env.REACT_APP_BUILD);
export const BUILD_TIME = stampedValue(process.env.REACT_APP_BUILD_TIME);
export const BUILD_SOURCE = stampedValue(process.env.REACT_APP_BUILD_SOURCE);

/**
 * The version-and-commit stamp for the top-nav badge, e.g. `V1.49 · add43ac91b2c`.
 * The commit is always shown, `unknown` included — a badge that quietly omits it
 * looks identical to one built from a known commit, which is the state this
 * stamp exists to make visible.
 */
export const versionStamp = (version, build) => `V${version} · ${build}`;

export const VERSION_STAMP = versionStamp(APP_VERSION, BUILD);

/** Whether the build this bundle came from could be identified at all. */
export const isBuildEstablished = () => BUILD !== UNKNOWN;
